import { createEntityAdapter } from '@ngrx/entity';
import { MessageData } from '../models/message-data.model';

export const messageEntityAdapter = createEntityAdapter<MessageData>({
  selectId: message => message.id,
  sortComparer:sortByTimestampAsc
});

function sortByTimestampAsc(a: MessageData, b: MessageData): number {
  return a.timestamp.localeCompare(b.timestamp) ?? 0;
}
